<script setup>
import BackgroundSection from './BackgroundSection.vue'
import content from '../content.js'

const mission = content.mission
</script>

<template>
  <BackgroundSection
    section-id="mission"
    :video="mission.video"
    :image="mission.image"
    overlay-class="bg-black/60"
  >
    <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 px-6 text-center md:text-left">
      <div data-aos="fade-right">
        <h2 class="text-2xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4 text-shadow">
          {{ mission.vision.title }}
        </h2>
        <p class="text-sm sm:text-lg md:text-xl leading-relaxed">
          {{ mission.vision.text }}
        </p>
      </div>
      <div data-aos="fade-left" data-aos-delay="200">
        <h2 class="text-2xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4 text-shadow">
          {{ mission.mission.title }}
        </h2>
        <p class="text-sm sm:text-lg md:text-xl leading-relaxed">
          {{ mission.mission.text }}
        </p>
      </div>
    </div>
  </BackgroundSection>
</template>
